import { noop } from 'lodash'
import { createStore } from 'zustand'

import { GenericalRecord } from '../../../../types/utilities'
import { promiseNoop } from '../../../../utils/promise'

import { RemoteTransferOptions, RemoteTransferStore } from './interface'

export const createRemoteTransferStore = ({
  searchForm
}: RemoteTransferOptions) =>
  createStore<RemoteTransferStore<GenericalRecord, GenericalRecord>>(
    (set, get) => ({
      rowKey: 'id',
      value: [],
      onChange: undefined,
      setValue(value) {
        set({ value })
        get().onChange?.(value)
      },
      searchForm,
      requestParams: {},
      setRequestParams(params) {
        const { searchForm, requestParams } = get()
        searchForm.setValues(params)
        set({
          requestParams: {
            ...requestParams,
            ...params
          }
        })
      },
      allData: {},
      data: [],
      error: undefined,
      loading: false,
      pagination: {
        current: 0,
        pageSize: 0,
        total: 0,
        totalPage: 0,
        changeCurrent: noop,
        changePageSize: noop,
        onChange: noop
      },
      reload: noop,
      fetchSearch: promiseNoop,
      fetchNextPage: noop,
      panelHeight: undefined,
      setPanelHeight(panelHeight) {
        set({ panelHeight })
      }
    })
  )
